export default "__VITE_ASSET__bf237f5b__"